import FieldMaxLengths from '../../../constants/FieldMaxLengths';

const isValidPhoneNumberLength = (countryCode, phoneNumber) =>
    countryCode?.length + phoneNumber?.length <= FieldMaxLengths.PHONE;

export default { isValidPhoneNumberLength };
